import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, Suspense } from 'react';
import jQuery from 'jquery';
import { GetCommonSettings } from '@themes/common/data';
import { createRoot } from 'react-dom/client';
import AppProvider from '@components/Shared/State/provider';
const DeliveryTime = lazy(() => import(/* webpackChunkName: 'DeliveryTime', webpackPrefetch: true */ './display'));
export default function LoadDeliveryTime(element) {
    const jQueryElement = jQuery(element);
    const data = jQueryElement.data();
    const settings = GetCommonSettings();
    const rootDom = createRoot(element);
    rootDom.render(_jsx(AppProvider, { children: _jsx(Suspense, Object.assign({ fallback: _jsx("div", { dangerouslySetInnerHTML: { __html: jQueryElement.html() } }) }, { children: _jsx(DeliveryTime, Object.assign({}, data, { settings: settings, element: jQueryElement })) })) }));
}
